import { NgModule } from '@angular/core';
import { FiAppTextSharedModule } from '../../../shared/app-text';
import { FiADIntegrationGroupMappingComponent } from './group-mapping.component';
import { FiSideListNewModule } from '../../../utilities/side-list-new/side-list-new.module';
import { CommonModule } from '@angular/common';
import { FiADIntegrationGroupMappingSelectTypeCellComponent } from './select-type-cell/select-type-cell.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FiAdIntegrationGroupMappingMappingsListComponent } from './mappings-list/mappings-list.component';
import { FiRollupContentModule } from '../../../shared/rollup/rollup-content.module';

@NgModule({
    imports: [
        FiAppTextSharedModule,
        FiSideListNewModule,
        CommonModule,
        FormsModule,
        MatMenuModule,
        MatButtonModule,
        FiRollupContentModule,
    ],
    declarations: [
        FiADIntegrationGroupMappingComponent,
        FiADIntegrationGroupMappingSelectTypeCellComponent,
        FiAdIntegrationGroupMappingMappingsListComponent,
    ],
    exports: [FiADIntegrationGroupMappingComponent],
    providers: [],
})
export class FiADIntegrationMappingModule {}
